<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Reviews</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'ReviewsPropertyName')"
            [blockData]="block.variables?.ReviewsPropertyName ?? ''"
            [placeholder]="propertyNamePlaceholder"
            variable="ReviewsPropertyName"
          ></app-block-text>
        </div>

        <div class="col-6">
          <app-block-text
            [type]="'action-link'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'ReviewsImageHref')"
            [blockData]="block.variables?.ReviewsImageHref ?? ''"
            [placeholder]="imageHrefPlaceholder"
            variable="ReviewsImageHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'ReviewsImageHrefSegmentRegex')"
            [selectedSegment]="block.variables?.ReviewsImageHrefSegmentRegex ?? ''"
          ></app-block-text>
        </div>
                <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            (handleOnChange)="onChange($event, 'ReviewsImage')"
            [blockData]="block.variables?.ReviewsImage ?? ''"
            [placeholder]="imagePlaceholder"
            variable="ReviewsPropertyName"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'ReviewsImageAlt')"
            [blockData]="block.variables?.ReviewsImageAlt ?? ''"
            [placeholder]="imageAltPlaceholder"
            variable="ReviewsImageAlt"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            [maxLength]="4000"
            (handleOnChange)="onChange($event, 'ReviewsText')"
            [blockData]="block.variables?.ReviewsText ?? ''"
            [placeholder]="textPlaceholder"
            variable="ReviewsText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div
            class="col-12 mb-3"
            [innerHTML]="$safeNavigationMigration(block.variables?.ReviewsPropertyName)"
          ></div>
          <div class="col-12 mb-3" *ngIf="block.variables?.ReviewsImage">
            <a
              target="_blank"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.ReviewsImageHref))"
              ><img
                [src]="$safeNavigationMigration(block.variables?.ReviewsImage)"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.ReviewsImageAlt)"
            /></a>
          </div>
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.ReviewsText)"></div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
